import {
    CANDIDATE_ADD_PROJECT_REQUEST,
    CANDIDATE_ADD_PROJECT_SUCCESS,
    CANDIDATE_ADD_PROJECT_FAIL,
} from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    result: null,
    error: "",
  };
  
  const CandidateAddProjectReducer = (state = initialState, action) => {
    switch (action.type) {
      case CANDIDATE_ADD_PROJECT_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case CANDIDATE_ADD_PROJECT_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case CANDIDATE_ADD_PROJECT_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default CandidateAddProjectReducer;